module.exports = __webpack_public_path__ + "img/User.08f475bf.svg";